import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "pop_up pop_detail preview",
  style: {"display":"block","height":"80%","position":"fixed"}
}
const _hoisted_2 = {
  class: "_intro sub_page",
  style: {"max-height":"100%","overflow-y":"auto"}
}
const _hoisted_3 = { class: "sub_page_tit" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "sub_page_con wrap_1120" }
const _hoisted_6 = { class: "bread_crumbs" }
const _hoisted_7 = { class: "faq_title" }
const _hoisted_8 = { class: "sub_page_con_view con_view" }
const _hoisted_9 = { class: "tit_wrap flex_wrap" }
const _hoisted_10 = { class: "con_tit" }
const _hoisted_11 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "pop_up_layer",
      style: {"display":"block"},
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "close_btn",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
      }, [...(_cache[2] || (_cache[2] = [
        _createElementVNode("img", {
          src: "img/close.png",
          alt: "닫기"
        }, null, -1)
      ]))]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("section", _hoisted_3, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "banner_wrap wrap_1120" }, [
            _createElementVNode("h2", null, "소개")
          ], -1)),
          _createElementVNode("div", {
            class: "sub_menu_tab wrap_1120",
            innerHTML: $setup.state.header
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("section", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[5] || (_cache[5] = _createStaticVNode("<a href=\"\" class=\"icon_wrap\" data-v-43d162f8><img src=\"img/home_icon.png\" alt=\"홈\" data-v-43d162f8></a><span class=\"icon_wrap\" data-v-43d162f8><img src=\"img/part_icon.png\" alt=\"소개\" data-v-43d162f8></span><a href=\"\" data-v-43d162f8>소개</a><span class=\"icon_wrap\" data-v-43d162f8><img src=\"img/part_icon.png\" alt=\"자주묻는 질문(FAQ)\" data-v-43d162f8></span>", 4)),
            _createVNode(_component_router_link, { to: "/intro" }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("자주묻는 질문(FAQ)", -1)
              ]))]),
              _: 1
            }),
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "icon_wrap" }, [
              _createElementVNode("img", {
                src: "img/part_icon.png",
                alt: "서울시 인터넷시민감시단 참여 신청은 어디서 하나요?"
              })
            ], -1)),
            _createElementVNode("span", _hoisted_7, _toDisplayString($setup.state.title), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString($setup.state.title), 1)
            ]),
            _createElementVNode("div", {
              class: "content_wrap",
              innerHTML: $setup.state.content
            }, null, 8, _hoisted_11),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "btn_wrap _default right_btn _board_type" }, [
              _createElementVNode("button", {
                class: "common_btn",
                type: "button"
              }, "목록")
            ], -1))
          ])
        ])
      ])
    ])
  ], 64))
}